import React, { useContext } from 'react';
import winnerWordlyImg from './cards/winner_wordly.png';
import winnerMemoryImg from './cards/winner_memory.png';
import winnerSpellingImg from './cards/winner_spelling.png';
import { dataContext } from '../../App';

export default function NewWinnerList({ setShowNewLeaderboardModal }) {
  const { setActiveLeaderboardName } = useContext(dataContext);

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', padding:'16px' }}>
        <img src={winnerWordlyImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_wordly')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={winnerMemoryImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_memory_hard')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
        <img src={winnerSpellingImg} onClick={()=>{setShowNewLeaderboardModal(true);setActiveLeaderboardName('winner_y_spelling')}} alt="" style={{ width: '100%', maxWidth: '100%',borderRadius:'6px', cursor:'pointer' }} />
      </div>
    </>
  );
};
